<template>
    <FormInput type="url" @invalid="onInvalid($event)" @input="onInput($event)" />
</template>

<script setup>
import FormInput from '@/Shared/Form/Input';
const onInput = (event) => {
    event.target.setCustomValidity('');
}
const onInvalid = (event) => {
    event.target.setCustomValidity('Bitte die komplette URL inkl. https:// eingeben.')
}
</script>
